import React, { useState, useRef, useEffect } from 'react';
import {
  Edit2,
  Palette,
  Share2,
  Copy,
  Archive,
  Trash2,
  ChevronRight,
  X,
} from 'lucide-react';

const ListContextMenu = ({
  list,
  position,
  onClose,
  onRename,
  onChangeIcon,
  onMove,
  onDuplicate,
  onArchive,
  onDelete,
  folders,
  currentFolderId,
}) => {
  const [showSubmenu, setShowSubmenu] = useState(null);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  const otherFolders = folders.filter((f) => f.id !== currentFolderId);

  return (
    <div
      ref={menuRef}
      className="fixed bg-white border border-gray-200 rounded-lg shadow-lg z-50 min-w-max"
      style={{
        top: `${position?.top}px`,
        left: `${position?.left}px`,
      }}
    >
      {/* Cambiar nombre */}
      <button
        onClick={() => {
          onRename();
          onClose();
        }}
        className="w-full text-left px-4 py-2 hover:bg-gray-100 flex items-center gap-3 text-sm transition"
      >
        <Edit2 className="w-4 h-4" />
        <span>Cambiar nombre</span>
      </button>

      {/* Cambiar icono */}
      <button
        onClick={() => {
          onChangeIcon();
          onClose();
        }}
        className="w-full text-left px-4 py-2 hover:bg-gray-100 flex items-center gap-3 text-sm transition"
      >
        <Palette className="w-4 h-4" />
        <span>Cambiar icono</span>
      </button>

      {/* Mover */}
      <div className="relative">
        <button
          onMouseEnter={() => setShowSubmenu('move')}
          onMouseLeave={() => setShowSubmenu(null)}
          onClick={() => setShowSubmenu(showSubmenu === 'move' ? null : 'move')}
          className="w-full text-left px-4 py-2 hover:bg-gray-100 flex items-center gap-3 text-sm transition"
        >
          <Share2 className="w-4 h-4" />
          <span>Mover</span>
          <ChevronRight className="w-3 h-3 ml-auto" />
        </button>

        {/* Submenu: Mover */}
        {showSubmenu === 'move' && (
          <div className="absolute left-full top-0 bg-white border border-gray-200 rounded-lg shadow-lg ml-2 min-w-max">
            {otherFolders.length > 0 ? (
              otherFolders.map((folder) => (
                <button
                  key={folder.id}
                  onClick={() => {
                    onMove(folder.id);
                    onClose();
                  }}
                  className="w-full text-left px-4 py-2 hover:bg-gray-100 text-sm transition block"
                >
                  {folder.nombre}
                </button>
              ))
            ) : (
              <div className="px-4 py-2 text-gray-400 text-sm">
                No hay otras carpetas
              </div>
            )}
          </div>
        )}
      </div>

      {/* Duplicar */}
      <button
        onClick={() => {
          onDuplicate();
          onClose();
        }}
        className="w-full text-left px-4 py-2 hover:bg-gray-100 flex items-center gap-3 text-sm transition"
      >
        <Copy className="w-4 h-4" />
        <span>Duplicar</span>
      </button>

      {/* Archivar */}
      <button
        onClick={() => {
          onArchive();
          onClose();
        }}
        className="w-full text-left px-4 py-2 hover:bg-gray-100 flex items-center gap-3 text-sm transition"
      >
        <Archive className="w-4 h-4" />
        <span>Archivar</span>
      </button>

      {/* Separador */}
      <div className="h-px bg-gray-200 my-1" />

      {/* Eliminar */}
      <button
        onClick={() => {
          if (window.confirm('¿Eliminar esta lista? Esta acción no se puede deshacer.')) {
            onDelete();
            onClose();
          }
        }}
        className="w-full text-left px-4 py-2 hover:bg-red-100 flex items-center gap-3 text-sm transition text-red-600"
      >
        <Trash2 className="w-4 h-4" />
        <span>Eliminar</span>
      </button>
    </div>
  );
};

export default ListContextMenu;
